import AppPage from '../../mixins/app-page'

import AppImgBg from '../app-img-bg'
import AppBtn from '../app-btn'


// URL list
import URL from '../../../config.url'


export default
{
    name: 'page-copyright',

    data()
    {   
        return {
            url: URL
        }
    },

    mixins:
    [
        AppPage
    ],

    components:
    {
        AppImgBg,
        AppBtn
    },

    mounted()
    {
        this.eventHub.$emit('bg-change', '/static/bg/bg-empty.jpg')
    }
}


// WEBPACK FOOTER //
// ./src/scripts/components/page-404/script.js